/**
 * Should opening a chat put the caret in its message field?
 *
 * Yes on a mouse-driven screen when nothing else holds the user: not on a
 * touch device (the on-screen keyboard would jump up over the chat), not while
 * a dialog is open, and not when the user is already typing somewhere else —
 * a search box, a rename field, another input.
 */
export function shouldAutofocusComposer(
  doc: Document,
  win: { matchMedia?: (query: string) => { matches: boolean } },
): boolean {
  if (!win.matchMedia?.('(pointer: fine)').matches) return false;
  if (doc.querySelector('[role="dialog"][aria-modal="true"], [role="alertdialog"]')) return false;
  const active = doc.activeElement;
  if (active instanceof HTMLElement && active !== doc.body && isEditable(active)) return false;
  return true;
}

function isEditable(el: HTMLElement): boolean {
  if (el.isContentEditable) return true;
  if (el instanceof HTMLTextAreaElement) return true;
  if (el instanceof HTMLInputElement) {
    return !['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file', 'image'].includes(el.type);
  }
  return el instanceof HTMLSelectElement;
}
